module.exports = __webpack_public_path__ + "img/db-don-bi-huy.c49af6e8.svg";